import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  fetchBookabilityFailure,
  fetchBookabilityStarted,
  fetchBookabilitySucceeded,
  PRICING_SECTION,
  setBookability,
} from '../../actions/availability';

export const initialState = window.ecom.redux_initial_state.resources || {};
const clearChildResources = createAction('resources/clearChildResources');

const updateFetchStatus = (state, action) => {
  const { travelDate, resourceIds, error } = action.payload;

  resourceIds.forEach((id) => {
    const dateBookability = state[id]?.bookability?.[travelDate] || {};
    state[id] = {
      ...state[id],
      bookability: {
        [travelDate]: { ...dateBookability, fetch: action.type, error },
      },
    };
  });
};

const ResourcesReducer = createReducer(initialState, {
  [fetchBookabilityStarted]: updateFetchStatus,
  [fetchBookabilitySucceeded]: updateFetchStatus,
  [fetchBookabilityFailure]: updateFetchStatus,
  [setBookability]: (state, action) => {
    const { json, pricingSection } = action.payload;

    if (!Array.isArray(json)) {
      return;
    }

    json.forEach((wrapper) => {
      const { resource, bookability } = wrapper;
      const { id } = resource;
      // If section is defined, this is for fetching price
      if (pricingSection) {
        const pricing = state[id]?.pricing || {
          [PRICING_SECTION.calendar]: {},
          [PRICING_SECTION.passenger]: {},
        };

        const currentSection = pricing[pricingSection];
        pricing[pricingSection] = { ...currentSection, ...bookability };

        state[id] = {
          ...state[id],
          ...resource,
          name: state[id]?.name || resource?.display_name || resource?.name,
          pricing,
        };
      } else {
        state[id] = {
          ...state[id],
          ...resource,
          name: state[id]?.name || resource?.display_name || resource?.name,
          bookability,
        };
      }
    });
  },
  [clearChildResources]: (state, action) => {
    state[action.payload].childResources = [];
  },
});

export default ResourcesReducer;
